<template>
  <div v-if="loading">
    <v-skeleton-loader type="article" class="transparent"></v-skeleton-loader>
  </div>
  <div v-else>
    <v-row align="center">
      <v-col cols="12" md="7">
        <h3 class="step-upload__title">Загрузите XLSX-документ</h3>
        <p class="step-upload__description">
          Пример шаблона для загрузки можно скачать

          <a :href="$model.wwwroot + '/blocks/manage_groups/timetable2/importCity/example.xlsx'" target="_blank">
            <v-icon color="green">mdi-microsoft-excel</v-icon>по ссылке
          </a>.
        </p>
      </v-col>
      <v-col cols="12" md="5">
        <v-file-input v-model="file" accept=".xlsx" label="Файл расписания" prepend-icon="mdi-file-excel"
          variant="solo-filled" density="comfortable" hide-details="auto" :disabled="loading"
          @update:model-value="onFileChange" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "StepUpload",
  props: {
    context: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      file: null,
      loading: false,
    };
  },
  methods: {
    onFileChange(value) {
      if (Array.isArray(value)) {
        this.file = value[0] ?? null;
      }
      this.upload();
    },
    upload() {
      if (!this.file || this.loading) {
        return;
      }

      const formData = new FormData();
      formData.append("cityTT", this.file);
      this.loading = true;

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/timetable2/importCity/importCityTT",
          formData
        )
        .then((response) => {
          this.$emit("uploaded", response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.step-upload {
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.step-upload__badge {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 14px;
}

.step-upload__title {
  font-size: 28px;
  line-height: 1.15;
  margin: 0 0 12px;
  color: #0f172a;
}

.step-upload__description {
  font-size: 16px;
  line-height: 1.65;
  color: #475569;
  margin: 0;
  max-width: 540px;
}

.step-upload__dropzone {
  padding: 20px;
  border: 1px dashed rgba(30, 41, 59, 0.18);
  background:
    radial-gradient(circle at top right, rgba(251, 191, 36, 0.12), transparent 28%),
    rgba(255, 255, 255, 0.92);
}
</style>
